export const formatDate = (dateToFormat) => {
    let newDate = null
    if (dateToFormat instanceof Date)
        newDate = dateToFormat
    else
        newDate = new Date(dateToFormat)

    const date = [
        newDate.getUTCDate().toString().padStart(2, '0'),
        (newDate.getUTCMonth() + 1).toString().padStart(2, '0'),
        newDate.getUTCFullYear(),
    ]

    return date.join('/')
}

export const formatXmlDate = (dateString) => {
    let newDate = null
    if (dateString instanceof Date)
        newDate = dateString
    else
        newDate = new Date(dateString)

    const date = [
        newDate.getFullYear(),
        (newDate.getMonth() + 1).toString().padStart(2, '0'),
        newDate.getDate().toString().padStart(2, '0'),
    ]

    return date.join('-')
}

export const formatDateTime = (dateToFormat) => {
    let newDate = null
    if (dateToFormat instanceof Date)
        newDate = dateToFormat
    else
        newDate = new Date(dateToFormat)

    const date = [
        newDate.getDate().toString().padStart(2, '0'),
        (newDate.getMonth() + 1).toString().padStart(2, '0'),
        newDate.getFullYear(),
    ]

    const time = [
        newDate.getHours().toString().padStart(2, '0'),
        newDate.getMinutes().toString().padStart(2, '0'),
        newDate.getSeconds().toString().padStart(2, '0')
    ]

    return date.join('/') + " " + time.join(':')
}

const parseDate = (str) => {
    const [day, month, year] = str.split('/');
    return new Date(`${year}-${month}-${day}`);
};

export const daysDiff = (date1, date2) => {
    const newDate1 = parseDate(date1);
    const newDate2 = parseDate(date2);

    const difference = newDate1.getTime() - newDate2.getTime();

    return Math.ceil(difference / (1000 * 3600 * 24) + 1);
};


export const getAgeByDobComplete = (date) => {
    const dob = new Date(`${date} 00:00:00`)
    const currentDate = new Date();
    let age = currentDate.getFullYear() - dob.getFullYear();
    const currentMonth = currentDate.getMonth();
    const currentDay = currentDate.getDate();
    const dobMonth = dob.getMonth();
    const dobDay = dob.getDate();

    if (currentMonth < dobMonth || (currentMonth === dobMonth && currentDay < dobDay)) {
        age--;
    }

    if (age < 1) return 1

    return age;
}